import { makeZodValidate as makeValidate } from '@occc-app/design-system';

import {
  CustomDataSchema,
  OfferFulfillmentPrioritySchema,
  OfferNameAndDescriptionSchema,
} from '@occc/validation';

export const ConfigurationSchema = OfferNameAndDescriptionSchema.merge(
  OfferFulfillmentPrioritySchema,
).extend({
  customData: CustomDataSchema,
});

export const validateConfiguration = makeValidate(ConfigurationSchema);
